import { RcClasses } from '../../../../foundation';
export var RcMenuClasses = RcClasses([], 'RcMenu');
